import axios from 'axios';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setStations(state, data) {
      state.list = data;
    },
  },
  actions: {
    fetchFromServer({ commit }) {
      axios.get('/api/stations')
        .then(response => commit('setStations', response.data))
        .catch(error => console.log(error));
    },
  },
};
